import React from "react";
import { useContext } from "react";
import Border from "./Border";
import Passpartout from "./Passpartout";

import { ControlContext } from "../../ControlContext.jsx";

export default function BorderSwitch({ borderDepth }) {
  const { borderThickness, frameType } = useContext(ControlContext);

  switch (borderThickness) {
    case 0:
      return <Border borderDepth={borderDepth} />;
    case 0.15:
    case 0.3:
      if (["Print", "Float", "Face Mount", "Canvas"].includes(frameType)) {
        return <Border borderDepth={borderDepth} />;
      } else {
        return <Passpartout borderDepth={borderDepth} />;
      }
  }
}
